import { Button, Flex, Select, Typography } from "antd";

import { useLogs } from "../../providers/LogProvider";
import { Logs } from "./logs";
import { ExportsButton } from "../../components/ExportsButton";
import { useState } from "react";
import { AddApp } from "../../components/AddApp";

export const Dashboard = () => {
  const { activeApp, onAppChange, apps } = useLogs();
  const [isPopupVisible, setPopupVisible] = useState<boolean>(false);
  console.log(apps);
  if (apps === null) {
    return <div>Loading...</div>;
  }

  if (apps.length === 0) {
    return (
      <Flex vertical align="center" justify="center" style={{ height: "100%" }}>
        <Typography.Text>
          Add your first app to start getting logs
        </Typography.Text>
        <Button
          type="primary"
          onClick={() => setPopupVisible(true)}
          style={{ marginTop: "20px" }}
        >
          Create application
        </Button>
        {isPopupVisible && <AddApp onCancel={() => setPopupVisible(false)} />}
      </Flex>
    );
  }

  return (
    <>
      <Flex justify="flex-start" style={{ margin: "0 0 10px" }}>
        <Select
          placeholder="Select App"
          style={{ minWidth: 180 }}
          defaultValue={activeApp}
          onChange={(appId) => onAppChange(appId, apps)}
        >
          {apps.map((el) => (
            <Select.Option key={el.id} value={el.id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
        <ExportsButton />
      </Flex>
      <Logs />
    </>
  );
};
